import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { makeGetBasketTotalQuantityState } from '../../../redux/basket/selectors/BasketSelector';
export const NavigationBasketBadge = () => {
    const basketCount = useSelector(makeGetBasketTotalQuantityState());
    if (!basketCount) {
        return null;
    }
    return (_jsx(Badge, { size: "sm", color: "branded", children: basketCount }));
};
